// File: frontend/src/components/common/ErrorBoundary.js
import React from 'react';

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught error at 12:30 AM BST, 07/03/2025:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-gray-900">Something Went Wrong</h1>
            <p className="mt-4 text-gray-600">Please try again later or contact support.</p>
            <p className="mt-2 text-sm text-gray-500">
              Error: {this.state.error?.message || 'Unknown error'}
            </p>
            <p className="mt-1 text-xs text-gray-400">
              Time: 12:30 AM BST, 07/03/2025
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;